import { render, staticRenderFns } from "./AppSettingsSupportingDocs.vue?vue&type=template&id=0f82aeb8&scoped=true&"
import script from "./AppSettingsSupportingDocs.vue?vue&type=script&lang=js&"
export * from "./AppSettingsSupportingDocs.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsSupportingDocs.vue?vue&type=style&index=0&id=0f82aeb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82aeb8",
  null
  
)

export default component.exports